import _implicitStylesheets from "./curatedListings.css";
import _implicitScopedStylesheets from "./curatedListings.scoped.css?scoped=true";
import _wdsCardGrid from "wds/cardGrid";
import {freezeTemplate, registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element} = $api;
  return [api_custom_element("wds-card-grid", _wdsCardGrid, {
    props: {
      "columnSize": "4:4@x-small 4:8@medium 4:12@large",
      "columnGap": "x-large",
      "listingRecords": $cmp.listings,
      "isLoading": $cmp.isLoading,
      "skeletonCount": "6"
    },
    key: 0
  })];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2gvj4hd3jmt";
tmpl.legacyStylesheetToken = "undefined-_curatedListings";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
